<template>
    <div class="step9">
        <h1>Aanvraagformulier</h1>
        <h2>Ondertekening</h2>

        <application-stepper current-step="9" :loading="!loaded">
            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <h3>Privacy verklaring</h3>

                <v-sheet class="ma-1 pa-2 overflow-auto" max-height="400px" elevation="2">
                    <p>
                        Dullertsstichting, Stichting Het Burger en Nieuwe Weeshuis en Stichting Sint Nicolai
                        Broederschap, allen gevestigd aan de Jansbinnensingel 22 6811 AK ARNHEM, hierna gezamenlijk te
                        noemen “de Stichtingen”, zijn verantwoordelijk voor de verwerking van persoonsgegevens zoals
                        weergegeven in deze privacyverklaring.
                    </p>

                    <p>
                        Contactgegevens:
                    </p>

                    <p>
                        <a href="https://www.dullertsstichting.nl" target="_blank">www.dullertsstichting.nl</a>,
                        <a href="https://www.burgerennieuweweeshuisarnhem.nl" target="_blank"
                            >www.burgerennieuweweeshuisarnhem.nl</a
                        >, <a href="https://www.nicolaibroederschap.nl" target="_blank">www.nicolaibroederschap.nl</a>,
                        <br />
                        Jansbinnensingel 22 6811 AK ARNHEM 026-4425192
                    </p>

                    <h4>Persoonsgegevens die wij verwerken</h4>

                    <p>
                        De Stichtingen verwerken uw persoonsgegevens omdat u deze zelf aan ons verstrekt. Hieronder
                        vindt u een overzicht van de persoonsgegevens die wij verwerken:
                    </p>

                    <ul class="mb-4">
                        <li>Voor- en achternaam</li>
                        <li>Geslacht</li>
                        <li>Geboortedatum</li>
                        <li>Geboorteplaats</li>
                        <li>Adresgegevens</li>
                        <li>Burgerlijke staat en voorzover van toepassing: naam en leeftijd partner</li>
                        <li>Voorzover van toepassing: voornaam, achternaam en leeftijd kinderen</li>
                        <li>Telefoonnummer</li>
                        <li>E-mail adres</li>
                        <li>
                            Overige persoonsgegevens (zoals inkomensgegevens en gegevens over bezit en schulden) die u
                            actief verstrekt bijvoorbeeld in correspondentie, telefonisch of tijdens een huisbezoek
                        </li>
                    </ul>

                    <p>
                        Wij vragen geen BSN-nummers. Wanneer deze ongevraagd toch worden toegezonden, bijvoorbeeld
                        doordat het nummer op een uitkeringsspecificatie niet is weggelakt, geldt de 2-jaars termijn
                        bedoeld in de hierna vermelde paragraaf “Hoe lang we persoonsgegevens bewaren”.
                    </p>

                    <h4>Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</h4>

                    <p>
                        De Stichtingen verwerken de volgende bijzondere en/of gevoelige persoonsgegevens van u:
                    </p>

                    <ul class="mb-4">
                        <li>
                            Gezondheid; dit geldt echter alleen voor aanvragen met een medische achtergrond, zoals
                            t.b.v. de aanvraag van een aangepaste fiets, stoel of bed, en uitsluitend nadat hiervoor een
                            speciale toestemmingsverklaring is getekend.
                        </li>
                    </ul>

                    <h4>Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken</h4>

                    <p>
                        De Stichtingen verwerken uw persoonsgegevens voor de volgende doelen:
                    </p>

                    <ul class="mb-4">
                        <li>
                            U te kunnen bellen of e-mailen indien dit nodig is om onze dienstverlening uit te kunnen
                            voeren
                        </li>
                        <li>
                            Om uw hulpvraag te kunnen beoordelen en af te handelen en – bij honorering van de hulpvraag
                            – de toegezegde goederen /diensten bij u af te (doen) leveren.
                        </li>
                    </ul>

                    <h4>Geautomatiseerde besluitvorming</h4>

                    <p>
                        De Stichtingen nemen geen besluiten op basis van geautomatiseerde verwerkingen over zaken die
                        (aanzienlijke) gevolgen kunnen hebben voor personen. Het gaat hier om besluiten die worden
                        genomen door computerprogramma’s of –systemen, zonder dat daar een mens (bijvoorbeeld een
                        medewerker van de Stichtingen) tussen zit.
                    </p>

                    <h4>Hoe lang we persoonsgegevens bewaren</h4>

                    <p>
                        De Stichtingen bewaren uw persoonsgegevens om bij vervolgaanvragen efficiënter te kunnen werken
                        en om uw eventuele voorgeschiedenis op het gebied van aanvragen te kunnen beoordelen. Hiervoor
                        geldt geen maximum-bewaartermijn. Wij hanteren echter een minimaliseringsbeleid, d.w.z. dat wij,
                        nadat een aanvraag volledig is afgerond (ook administratief, d.w.z. na maximaal 2 jaar na
                        toekenning of afwijzing) alle aanvraag specifieke gegevens (zoals correspondentie, financiële
                        gegevens) verwijderen.
                    </p>

                    <h4>Delen van persoonsgegevens met derden</h4>

                    <p>
                        De Stichtingen verkopen uw gegevens niet aan derden. Wij verstrekken persoonsgegevens
                        uitsluitend aan derden indien en voorzover dit nodig is voor de uitvoering van uw hulpvraag, om
                        te voldoen aan een wettelijke verplichting of om de eventuele hulpverlener die uw aanvraag
                        begeleidt te informeren en op de hoogte te houden. Met bedrijven die uw gegevens verwerken in
                        onze opdracht, sluiten wij een bewerkersovereenkomst om te zorgen voor eenzelfde niveau van
                        beveiliging en vertrouwelijkheid van uw gegevens. De uitvoerende Stichting van uw hulpvraag
                        blijft verantwoordelijk voor deze verwerkingen.
                    </p>

                    <h4>Cookies of vergelijkbare technieken</h4>

                    <p>
                        De Stichtingen gebruiken op hun website alleen functionele cookies en analytische cookies die
                        geen inbreuk maken op uw privacy.
                    </p>

                    <h4>Gegevens inzien, aanpassen of verwijderen</h4>

                    <p>
                        U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te laten verwijderen
                        (verwijdering alleen voordat een besluit over uw aanvraag is genomen of, nadat eenmaal besluit
                        over uw aanvraag is genomen: na verloop van de wettelijke bewaartermijn). Daarnaast heeft u het
                        recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken
                        tegen de verwerking van uw persoonsgegevens door Stichting Het Burger en Nieuwe Weeshuis en
                        heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt
                        indienen om de persoonsgegevens van u, waarover wij beschikken, in een computerbestand naar u te
                        sturen. U kunt een verzoek tot inzage, correctie, verwijdering van uw persoonsgegevens of
                        verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens
                        sturen naar <a href="mailto:privacy@dullertsstichting.nl">privacy@dullertsstichting.nl</a>. Om
                        er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw
                        identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine
                        readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en
                        burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel
                        mogelijk, maar binnen vier weken, op uw verzoek. De Stichting Het Burger en Nieuwe Weeshuis wil
                        u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale
                        toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link:
                        <a
                            href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons"
                            target="_blank"
                            >https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons</a
                        >
                    </p>

                    <h4>Hoe wij persoonsgegevens beveiligen</h4>

                    <p>
                        Stichting Het Burger en Nieuwe Weeshuis neemt de bescherming van uw gegevens serieus en neemt
                        passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en
                        ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd
                        zijn of er aanwijzingen zijn van misbruik, neem dan contact op met
                        <a href="mailto:privacy@dullertsstichting.nl">privacy@dullertsstichting.nl</a>.
                    </p>

                    <h4>Functionaris gegevensbescherming</h4>

                    <p>
                        De heer B. Huibers is de Functionaris Gegevensbescherming van de Stichtingen. Hij is te bereiken
                        via <a href="mailto:privacy@dullertsstichting.nl">privacy@dullertsstichting.nl</a>
                    </p>

                    <p>Versie: januari 2020.</p>
                </v-sheet>

                <v-checkbox
                    v-model="application.enteredTruthfully"
                    :error="hasErrors('enteredTruthfully')" :error-messages="handleErrors('enteredTruthfully')"
                    class="mx-2"
                    label="Ik verklaar hierbij alles naar waarheid te hebben ingevuld en kennis te hebben genomen van
bovenstaande privacyverklaring en geef uitdrukkelijk toestemming tot het registreren van de in dit
aanvraagformulier ingevulde persoonsgegevens."
                ></v-checkbox>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Indienen</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
    name: 'step9-signature',
    components: {
        ApplicationStepper,
        VErrorMessages,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        application: {
            enteredTruthfully: null,
            privacyConsent: null,
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step9' }),
    },
    watch: {
        'application.enteredTruthfully'(value) {
            this.application.privacyConsent = value;
        },
    },
    created: function() {
        const that = this;

        this.step9Load().then(function() {
            that.application.enteredTruthfully = that.vuex.application.enteredTruthfully;
            that.application.privacyConsent = that.vuex.application.privacyConsent;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step9Load', 'step9Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step9Submit(this.$data).finally(function() {
                that.$router.push({ name: 'step8_attachment' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step9Submit(this.$data)
                .then(function() {
                    that.$router.push({ name: 'finish' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        if (typeof response.data.error.messages === 'string') {
                            that.errorMessages = [response.data.error.messages];
                        } else {
                            that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                        }
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
